import React from 'react';
import { Field } from 'redux-form';
import { Datagrid, ReferenceManyField, ReferenceArrayInput, SelectInput, SelectArrayInput, TextField } from 'react-admin';
import { FormDataConsumer } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import CampaignLink from './Helpers/CampaignLink';
import CanViewParentAction from './Helpers/CanViewParentAction';
import CanViewSubActions from './Helpers/CanViewSubActions';
import ParentCampaignLink from './Helpers/ParentCampaignLink';

import { ExecutionTypeDropdown } from './StaticData/ExecutionTypes';
import { PaceTypeDropdown } from './StaticData/PaceTypes';
import PopoverHelp from '../Popovers/Help';
import StatusField from './StatusField';

const styles = createStyles({
  popover: {
    display: 'inline-block'
  },
  dropdown: {
    minWidth: 230
  }
});

type Props = {
  basePath: string,
  classes: any,
  dropdownReference: string,
  resource: string,
  record: any
};

const CampaignGroups = (props: Props) => (
  <div>
    <FormDataConsumer>
      {({ formData, ...rest }) => CanViewParentAction(formData) &&
        <div>
          <div style={{ fontSize: 14 }}>Parent Campaign</div>
          <Field
            basePath={props.basePath}
            component={ParentCampaignLink}
            linkId={props.record.parent_action && props.record.parent_action.id}
            linkName={props.record.parent_action && props.record.parent_action.name}
            name="parent_action" /><br />
        </div>
      }
    </FormDataConsumer>

    <FormDataConsumer>
      {({ formData, ...rest }) => CanViewSubActions(formData) &&
        <div>
          <Field
            allowEmpty
            className={props.classes.dropdown}
            component={ReferenceArrayInput}
            filter={{ sub_campaignable: true, parent_id: props.record.id }}
            label="Sub Campaigns"
            name="campaign_group.sub_actions"
            record={props.record}
            resource={props.resource}
            reference={props.dropdownReference}
            sort={{ field: 'name', order: 'ASC' }}
            source="campaign_group.sub_actions"
          >
            <Field
              component={SelectArrayInput}
              name="campaign_group.sub_actions"
              source="campaign_group.sub_actions" />
          </Field>

          <div>
            <Field
              choices={PaceTypeDropdown}
              component={SelectInput}
              label="Pace Type"
              name="campaign_group.pace_type"
              source="campaign_group.pace_type" />
            <PopoverHelp
              className={props.classes.popover}
              content="TRAFFIC: Campaign is targeted to the traffic and does not stick to a user.  USER: Campaign is targeted to a user for the duration of their browsing session" />
          </div><br />

          <div>
            <Field
              choices={ExecutionTypeDropdown}
              component={SelectInput}
              label="Execution Type"
              name="campaign_group.execution_type"
              source="campaign_group.execution_type" />
            <PopoverHelp
              className={props.classes.popover}
              content="ALL: All sub-campaigns are executed. Targeting and allocation are respected.  ONE: One sub-campaign is selected. Only allocation is respected, Targeting is not.  FIRST MATCH: Only one sub-campaign is randomly selected based on the targeting criteria" />
          </div><br /><br />

          <ReferenceManyField
            allowEmpty
            basePath={props.basePath}
            filter={{ children_only: true }}
            label="Sub Campaigns"
            record={props.record}
            reference={props.dropdownReference}
            resource={props.resource}
            sort={{ field: 'name', order: 'ASC' }}
            target="parent_id"
          >
            <Datagrid>
              <TextField source="code" />
              <CampaignLink basePath={props.basePath} record={props.record} />
              <StatusField source="active" record={props.record} />
              <TextField source="pace" />
            </Datagrid>
          </ReferenceManyField>
        </div>
      }
    </FormDataConsumer>
  </div>
);

export default withStyles(styles)(CampaignGroups);



// WEBPACK FOOTER //
// ./src/views/Common/Partials/CampaignGroups.tsx